import * as React from 'react';
import { AnchorListItem } from './AnchorListItem';
import { AppName } from '@pec/aion-ui-core/interfaces/appName';
import { NavLinkListItem } from './NavLinkListItem';
import { useTranslation } from 'react-i18next';
import SearchIcon from '@material-ui/icons/Search';
import ShareIcon from '@material-ui/icons/Share';
import { IOrganization, OrganizationFeature } from '@pec/aion-ui-core/interfaces/organization';
import { isComplianceRegionUS } from '@pec/aion-ui-core/helpers/complianceRegion';

type Props = {
  organization: IOrganization;
};

const Icon = (useSearchAndConnectLabel: boolean) => {
  return useSearchAndConnectLabel ? <SearchIcon /> : <ShareIcon />;
};

const Text = (isUSComplianceRegion: boolean, hasLegacySearchCutover: boolean, t: any) => {
  if (hasLegacySearchCutover) {
    return t('components.searchAndConnectAmpersand', 'Search & Connect');
  }

  return isUSComplianceRegion
    ? t('components.connect', 'Connect')
    : t('components.searchAndConnect', 'Search and Connect');
};

export const Connect: React.FC<Props> = ({ organization }) => {
  const { id, features } = organization;
  const { t } = useTranslation('connect');
  const isUSComplianceRegion = isComplianceRegionUS(features);
  const hasLegacySearchCutover = features.includes(OrganizationFeature.LegacySearchCutover);
  const iconElement = Icon(!isUSComplianceRegion || hasLegacySearchCutover);
  const textElement = Text(isUSComplianceRegion, hasLegacySearchCutover, t);

  return process.env.REACT_APP_NAME === AppName.AionConnectUI ? (
    <NavLinkListItem divider icon={iconElement} to={`/organizations/${id}/connect`}>
      {textElement}
    </NavLinkListItem>
  ) : (
    <AnchorListItem divider icon={iconElement} href={`/organizations/${id}/connect`}>
      {textElement}
    </AnchorListItem>
  );
};
